import styled from 'styled-components';
import { calculateGridItemChildWidth } from '../../../commonStyles/innerGridItemColumn';
import mediaQuery from '../../../helpers/mediaQuery';
import spacing from '../../../helpers/spacing';
import fluidGridColumns from '../../../theme/fluidGridColumns';

export const GridAlignedText = styled.span`
  display: flex;
  justify-content: space-between;
  margin: auto;
  align-items: center;
  text-align: left;

  padding: 0 ${spacing(2)};
  ${mediaQuery.tabletPortrait`
    max-width: ${calculateGridItemChildWidth(
      fluidGridColumns.tabletPortrait,
      6,
      'tabletPortrait'
    )};
    padding: 0;
  `}
`;
